<template>
  <div class="bg-white">
    <v-col :class="$vuetify.breakpoint.xsOnly ? '' : 'pt-2'" cols="12">
      <v-row class="justify-end align-center">
        <v-col sm="12" md="4">
          <div
            :class="
              trade_card.status == 'Inactive' ? 'Upcoming ' : 'not-status mr-2'
            "
          >
            <!-- @mouseover="currentPLTooltip = true"
              @mouseout="currentPLTooltip = false" -->
            <v-tooltip
              content-class="tooltip"
              color="#F7FAFF"
              bottom
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  {{ trade_card.status == "Inactive" ? "Upcoming" : "Posted" }}
                </div>
              </template>
              <span class="tooltip-text">{{ statusContent }}</span>
            </v-tooltip>
            <!-- <p id="upcoming-tt" v-if="currentPLTooltip">upcoming</p> -->
          </div>
        </v-col>
        <v-divider
          :class="trade_card.status == 'Closed' ? 'ml-2' : ''"
          class="my-2 mr-4"
          vertical
        >
        </v-divider>
        <v-col sm="12" md="4">
          <div class="time">
            <span> {{ getTime(trade_card.created) }} </span>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'mt-4' : 'pt-4'">
      <v-row
        v-if="trade_card.status != 'Inactive'"
        class="justify-end align-center"
      >
        <v-col sm="12" md="4">
          <div
            :class="
              trade_card.status == 'Active' ? ' Live mr-2' : 'not-status mr-2'
            "
          >
            <v-tooltip
              content-class="tooltip"
              color="#F7FAFF"
              bottom
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">Live</div>
              </template>
              <span class="tooltip-text">{{ statusContent }}</span>
            </v-tooltip>
          </div>
        </v-col>
        <v-divider
          :class="trade_card.status == 'Closed' ? 'ml-2' : ''"
          class="my-2 mr-4"
          vertical
        >
        </v-divider>
        <v-col sm="12" md="4">
          <div class="time">
            <span
              :style="!trade_card.trade_live_time ? 'visibility: hidden' : ''"
            >
              {{ getTime(trade_card.trade_live_time) }}
            </span>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'mt-4' : 'pt-4'">
      <v-row
        v-if="trade_card.status == 'Closed'"
        class="justify-end align-center"
      >
        <v-col sm="12" md="4">
          <div class="Closed">
            <v-tooltip
              content-class="tooltip"
              color="#F7FAFF"
              bottom
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">Closed</div>
              </template>
              <span class="tooltip-text">{{ statusContent }}</span>
            </v-tooltip>
          </div>
        </v-col>
        <v-divider class="my-2 ml-2 mr-4" vertical> </v-divider>
        <v-col sm="12" md="4">
          <div class="time">
            <span
              :style="
                !trade_card.trade_closing_time ? 'visibility: hidden' : ''
              "
            >
              {{ getTime(trade_card.trade_closing_time) }}
            </span>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: ["trade_card"],
  data() {
    return {
      currentPLTooltip: false,
      upcom: "upcoming",
    };
  },
  computed: {
    statusContent() {
      if (this.trade_card.status == "Active") {
        return "This is a live trade. Market entry was done on the Entry Price. Hold until Exit Price. Book profit/Cut loss on Target Price/Stop Loss";
      } else if (this.trade_card.status == "Inactive") {
        return "This is an upcoming trade and is not Live yet. Market entry to be done on the Entry Price.";
      } else if (this.trade_card.status == "Closed") {
        return "This is a past trade";
      } else {
        return "This trade is expired";
      }
    },
  },
  methods: {
    getTime(value) {
      return dayjs(value).format("h:mm A D MMM");
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip-text {
  color: #111111 !important;
}
#upcoming-tt {
  width: 10%;
  margin-left: 20px !important;
  background-color: lightblue;
}
#upcoming-tt::after {
  content: " ";
  position: absolute;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent lightblue transparent;
}
#upcoming-tt {
  font-size: 13px;
  text-align: center;
  position: relative;
  z-index: 1;
  padding: 5px;
  border-radius: 6px;
  position: fixed;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}
.time > span {
  color: rgba(51, 51, 51, 0.87);
  text-align: center;
  font-size: 0.645rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: -0.02063rem;

  span {
    color: rgba(51, 51, 51, 0.87);
    font-size: 0.5625rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.01688rem;
  }
}
.Upcoming {
  padding: 0.18rem 0.6rem;
  display: flex;
  align-items: center;
  height: fit-content;
  border-radius: 1.25rem;
  background: rgba(45, 140, 255, 0.16);
  width: fit-content;
  div {
    color: #2d8cff;
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.0225rem;
  }
}
.not-status {
  color: rgba(51, 51, 51, 0.6);
  text-align: left;
  margin-left: 2rem;
  // text-align: center;
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: -0.0225rem;
}

.Closed {
  padding: 0.18rem 0.6rem;
  padding-right: 0.75rem;
  width: fit-content;
  display: flex;
  align-items: center;
  height: fit-content;
  border-radius: 1.25rem;
  background: rgba(235, 87, 87, 0.16);
  margin-left: 1.5rem;
  div {
    color: #eb5757;
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.0225rem;
  }
}
.Live {
  width: fit-content;
  padding: 0.18rem 0.6rem;
  padding-right: 0.75rem;
  display: flex;
  align-items: center;
  height: fit-content;
  border-radius: 1.25rem;
  background: rgba(39, 174, 96, 0.16);
  margin-left: 1.5rem;
  div {
    color: #27ae60;
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.0225rem;
  }
}
@media only screen and (max-width: 768px) {
  .bg-white {
    // background-color: #fff;
    // z-index: 3;
  }
  .Closed {
    color: #eb5757 !important;
    display: block;
    text-align: center;
    font-family: Avenir;
    height: none;
    width: 0%;
    margin-left: 8px;
    font-size: 0.625rem;
    font-style: normal;
    font-weight: 800;
    line-height: 4px;
    letter-spacing: -0.01875rem;
    background: none;
    padding: 0;
    margin-right: 0rem;
    margin-left: 2rem;

    // margin-top: 8px;
  }
  .Upcoming {
    color: #2d8cff;
    text-align: center;
    font-family: Avenir;
    font-size: 0.625rem;
    font-style: normal;
    font-weight: 800;
    // line-height: normal;
    letter-spacing: -0.01875rem;
    background: none;
    padding: 0;
    line-height: 6px;
    margin-left: 0rem;
    // margin-top: 8px;
  }
  .Live {
    color: #27ae60;
    display: block;
    text-align: center;
    font-family: Avenir;
    height: none;
    width: 0%;
    margin-left: 2rem;
    margin-right: 0px;
    font-size: 0.625rem;
    font-style: normal;
    font-weight: 800;
    line-height: 4px;
    letter-spacing: -0.01875rem;
    background: none;
    padding: 0;
    // margin-left: 0rem;
  }
}
</style>
